import { combine } from 'effector'
import { model as i18n } from '~/core/i18n'

export const $authFormsTabsTranslations = combine(i18n.$t, ({ t }) => ({
  phone: t('phone_number'),
  email: t('username_email'),
}))
